module.exports = __webpack_public_path__ + "gamblingcommission.png?d5814b84c84090be9536101fea953e31";


//////////////////
// WEBPACK FOOTER
// ./src/assets/gamblingcommission.png
// module id = 179
// module chunks = 0